export default __webpack_public_path__ + "static/02-0e4658ca7cbe811f45cb47f22b5f3b85.webp";